import HTTP from '@rocketfid/api'

const state = {
  items: [],
  filterStatus: 'all'
}

// getters
const getters = {
  banners: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getByStatus: (state) => (status) => {
    if (status.length === 0 || status == 'all') {
      return state.items
    }
    return state.items.filter(banner => status == banner.status)
  },
  getFilterStatus: (state) => {
    return state.filterStatus
  }
}

// actions
const actions = {
  loadBanners ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .banner.getAll()
      .then((banners) => {
        dispatch('banners/resetBanners', null, { root: true })
        commit('ADD_BANNER_ITEMS', { items: banners })
        return banners
      })
  },

  loadBanner ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .banner.get(id)
      .then((banner) => {
        commit('UPDATE_BANNER_ITEM', { item: banner })
        return banner
      })
  },

  resetBanners ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('RESET_BANNER_ITEMS')
      resolve()
    })
  },

  addBanner ({ commit, rootGetters }, { banner }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .banner.create(banner)
      .then((banner) => {
        commit('ADD_BANNER_ITEM', { item: banner })
        return banner
      })
  },

  updateBanner ({ commit, rootGetters }, { banner }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .banner.update(banner)
      .then((banner) => {
        commit('UPDATE_BANNER_ITEM', { item: banner })
        return banner
      })
  },

  removeBanner ({ commit, rootGetters }, { banner }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .banner.delete(banner)
      .then((banner) => {
        commit('REMOVE_BANNER_ITEM', { item: banner })
      })
  },

  getBannerStats ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .axios.get(process.env.API + '/banner/' + id + '/reporting/stats/')
      .then((results) => {
        return {
          id: id,
          results: results.data
        }
      })
  },

  setFilterStatus ({ commit, rootGetters }, { filterStatus }) {
    commit('UPDATE_FILTER_STATUS', { status: filterStatus })
  },

  async addCsvFile ({ commit, rootGetters }, { banner: banner, csvFile }) {
    let sitekey = rootGetters['account/currentSitekey']
    var formData = new FormData()

    formData.append("csv", csvFile)

    let response = await HTTP
      .setInstance(sitekey)
      .axios.post(process.env.API + '/banner/' + banner.id + '/csv/', formData)

    commit('UPDATE_BANNER_ITEM', { item: response.data })
    return response.data
  },

  async updateCsvFile ({ commit, rootGetters }, { banner: banner, csvFile }) {
    let sitekey = rootGetters['account/currentSitekey']
    var formData = new FormData()

    formData.append("csv", csvFile)

    let response = await HTTP
      .setInstance(sitekey)
      .axios.post(process.env.API + '/banner/' + banner.id + '/updatecsv/', formData)

    commit('UPDATE_BANNER_ITEM', { item: response.data })
    return response.data
  }
}

// mutations
const mutations = {
  ADD_BANNER_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_BANNER_ITEMS: (state) => {
    state.items = []
  },

  ADD_BANNER_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_BANNER_ITEM: (state, { item }) => {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },

  REMOVE_BANNER_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  },

  UPDATE_FILTER_STATUS: (state, { status }) => {
    state.filterStatus = status;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/banners.js